const mapAttachment = (attachment) => ({
    id: +attachment?.id,
    name: attachment?.original_name || attachment?.server_name || attachment?.path || "",
    extension: attachment?.extension || "",
    path: attachment?.path || "",
});

const mapComment = (comment) => ({
    id: +comment?.id,
    text: comment?.content || "",
    author: `${comment?.relUser?.name || ""} ${comment?.relUser?.surname || ""}`.trim(),
    createdAt: comment?.created_at,
    attachments: (comment?.relAttachments || []).map(mapAttachment),
});

const getAttachmentNameParts = (attachment) => {
    const rawName = attachment?.name || "";
    const rawExtension = (attachment?.extension || "").replace(/^\./, "");

    if (!rawName) {
        return { fileName: "", extension: rawExtension };
    }

    if (rawExtension) {
        const suffix = `.${rawExtension}`;
        if (rawName.toLowerCase().endsWith(suffix.toLowerCase())) {
            return {
                fileName: rawName.slice(0, -suffix.length) || rawName,
                extension: rawExtension,
            };
        }
        return {
            fileName: rawName,
            extension: rawExtension,
        };
    }

    const dotIndex = rawName.lastIndexOf(".");
    if (dotIndex <= 0 || dotIndex === rawName.length - 1) {
        return { fileName: rawName, extension: "" };
    }

    return {
        fileName: rawName.slice(0, dotIndex),
        extension: rawName.slice(dotIndex + 1),
    };
};

const parseErrorMessage = (error) => {
    if (error?.graphQLErrors?.length) {
        return error.graphQLErrors[0]?.message || "Request error";
    }
    return error?.message || "Request error";
};

const CommentsBackendHelper = {
    mapAttachment,
    mapComment,
    getAttachmentNameParts,
    parseErrorMessage,
};

export default CommentsBackendHelper;
